module.exports = __webpack_public_path__ + "static/media/IMG_0704.15b1a6cf.HEIC";